(function ($) {
    $.fn.templatePartner = function () {
        return this.each(() => {

            const $pageContentContainer = $('.page-content-container');
            const $partnerPageContainer = $('.partner-page-container');
            const $map = $pageContentContainer.find('.google-map-module-container').closest('.page-row');

            if($map.length > 0){
                $partnerPageContainer.after($map);
            }

            $pageContentContainer.show();
            
        });
        
    }

    $(() => {
        $('body.template-partner').templatePartner();
    })

})($);


// WEBPACK FOOTER //
// ./scripts/templates/template-partner.js